<div class="person-event-editor-page" [class.person-event-editor-page--ministerial]="isMinisterialActivity">
  <div class="content-container">
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="errorMessage && !isLoading" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ errorMessage }}</p>
    </div>

    <mat-card
      *ngIf="!isLoading && !errorMessage && person"
      class="editor-card"
      [class.editor-card--ministerial]="isMinisterialActivity"
      [class.editor-card--ministerial-mobile-full]="isMinisterialActivity">
      <app-person-ministry-editor-form
        *ngIf="isMinistry || isMinistryChange || isMinisterialActivity"
        [person]="person"
        [mode]="(isMinistryChange || isMinisterialActivity) && !currentEvent ? 'change' : 'correction'"
        [ministries]="ministries"
        [appointments]="appointments"
        [assignments]="assignments"
        [units]="context.units"
        [currentAreas]="context.currentMinisterialAreas"
        [ministryEvents]="ministryEvents"
        [appointmentEvents]="appointmentEvents"
        [assignmentEvents]="assignmentEvents"
        [currentEvent]="currentEvent"
        [canManageFullMinisterialActivity]="canManageMinisterialActivity"
        (cancelled)="goBack()"
        (saved)="onSaved()"></app-person-ministry-editor-form>

      <app-person-appointment-editor-form
        *ngIf="isAppointment"
        [person]="person"
        [appointments]="appointments"
        [communities]="context.communities"
        [ministryEvents]="ministryEvents"
        [assignmentEvents]="assignmentEvents"
        [appointmentEvents]="appointmentEvents"
        [currentEvent]="currentEvent"
        (cancelled)="goBack()"
        (saved)="onSaved()"></app-person-appointment-editor-form>

      <app-person-assignment-editor-form
        *ngIf="isAssignment"
        [person]="person"
        [assignments]="assignments"
        [communities]="context.communities"
        [ministryEvents]="ministryEvents"
        [appointmentEvents]="appointmentEvents"
        [assignmentEvents]="assignmentEvents"
        [currentEvent]="currentEvent"
        (cancelled)="goBack()"
        (saved)="onSaved()"></app-person-assignment-editor-form>

      <app-person-activity-editor-form
        *ngIf="isActivity"
        [person]="person"
        [activities]="activities"
        [activityRoles]="activityRoles"
        [activityEvents]="activityEvents"
        [currentEvent]="currentEvent"
        (cancelled)="goBack()"
        (saved)="onSaved()"></app-person-activity-editor-form>

      <app-person-religious-event-editor-form
        *ngIf="isReligiousEvent"
        [person]="person"
        [religiousEvents]="religiousEvents"
        [currentEvent]="currentEvent"
        (cancelled)="goBack()"
        (saved)="onSaved()"></app-person-religious-event-editor-form>
    </mat-card>
  </div>
</div>
